import * as React from "react";

function IconMedicineSyrup({
  size = 24,
  color = "currentColor",
  stroke = 2,
  ...props
}) {
  return <svg xmlns="http://www.w3.org/2000/svg" className="icon icon-tabler icon-tabler-medicine-syrup" width={size} height={size} viewBox="0 0 24 24" strokeWidth={stroke} stroke={color} fill="none" strokeLinecap="round" strokeLinejoin="round" {...props}><path stroke="none" d="M0 0h24v24H0z" fill="none" /><path d="M8 21h8a1 1 0 0 0 1 -1v-10a3 3 0 0 0 -3 -3h-4a3 3 0 0 0 -3 3v10a1 1 0 0 0 1 1z" /><path d="M10 14h4" /><path d="M12 12v4" /><path d="M10 7v-3a1 1 0 0 1 1 -1h2a1 1 0 0 1 1 1v3" /></svg>;
}

export default IconMedicineSyrup;